import { BuildingService } from './../../services/building.service';
import { StateService } from '@uirouter/angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {forkJoin, Subscription} from "rxjs";
import * as _ from 'lodash';
import { SessionService } from '@edl-development/edl-common';
import { PaetepPortalService } from 'src/app/services/paetep-portal.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { LocalStorageKeys } from 'src/app/model/enum/local-storage-keys.enum';
import { SessionHelpersService } from 'src/app/services/session-helpers-service/session-helpers.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
    constructor(
        private stateService: StateService,
        private sessionService: SessionService,
        private sessionHelpersService: SessionHelpersService
    ) { }

    ngOnInit(): void {
        this.sessionHelpersService
            .loadSessionData()
            .then(() => this.navigateAfterLoading());
    }

    private navigateAfterLoading = () => {
        if (this.sessionService.redirectState) {
            let redirect: { name: string, params: any } = this.sessionService.redirectState;
            this.sessionService.redirectState = null;
            this.stateService.go(redirect.name, redirect.params);
        }
        else {
            this.stateService.go('authenticated.dashboard.view', { loggedInPortal: this.sessionService.PortalSettings?.URLSubdirectory });
        }
    }
}
